import { IconButton, Grid, Typography } from "@mui/material";
import { InfoContainer } from "./components";
import { useDispatch, useSelector } from "react-redux";
import { copyToClipboard } from "../../../helpers";
import { apiSetAlert } from "../../../api/appApi";
import { NotAvailable } from "./ChortkeOffline";
import { useNavigate } from "react-router-dom";
import BasicButton from "components/BasicInputs/BasicButton";
import CopyImg from "assets/images/Copy.svg";
import PostmanImage from "assets/svg/postman.svg";
import SwaggerImage from "assets/images/SwaggerImage.png";
import { Close, InfoOutlined } from "@mui/icons-material";
import { useState } from "react";
import Hint from "../../Shared/Hint";
import ApiTokenImage from "assets/images/ApiTokenImage.png";
import DownloadIcon from "assets/icons/DownloadIcon";
import CopyIcon from "assets/icons/CopyIcon";

const API = () => {
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  // @ts-ignore
  const { business, token } = useSelector((state) => state).businessReducer.business;

  return (
    <InfoContainer>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          {business.subscription && [4, 9, 12, 15, 16, 19, 20, 23, 24, 27, 28,35,36].includes(business.subscription.id) ? (
            <div className="flex flex-col items-center">
              <Hint
                message={
                  <>
                    <span>
                      برای دریافت Token کسب و کار خود جهت اتصال به وب سرویس چرتکه از این قسمت استفاده نمایید.
                      همچنین جهت مشاهده راهنمای سامانه از{" "}
                    </span>
                    <a
                      className="text-info"
                      href={
                        "https://www.chortke.app/%d9%85%d8%b3%d8%aa%d9%86%d8%af%d8%a7%d8%aa-api/%d8%b1%d8%a7%d9%87-%d8%a7%d9%86%d8%af%d8%a7%d8%b2%db%8c/"
                      }
                    >
                      مستندات رابط برنامه نویسی چرتکه
                    </a>
                    <span> استفاده نمایید</span>
                  </>
                }
              />

              <div className="flex flex-col justify-center items-center h-96 w-96 border rounded-md border-slate-300 p-6 gap-4">
                <img src={ApiTokenImage} alt="" className="mb-10" />
                <span className="text-xl">API TOKEN</span>
                <BasicButton
                  variant="contained"
                  className="w-full"
                  onClick={() => {
                    dispatch(apiSetAlert("کپی شد", "success"));
                    copyToClipboard(token);
                  }}
                >
                  <CopyIcon color="#ffffff" />
                  <span>کپی کن</span>
                </BasicButton>
              </div>
              <div className="w-96 flex flex-col gap-4 my-10">
                <div className="text-dark-3 my-2">لینک های کمکی</div>
                <div className="flex w-full border border-[#CAD1DE] rounded-md min-h-[72px] flex-row items-center justify-between px-4 ">
                  <a
                    target="_blank"
                    href="https://chortke.app/document/chortke-api.postman_collection"
                    className="flex flex-row p-4"
                    download="chortke-api"
                  >
                    <DownloadIcon color="#1062D0" />
                  </a>
                  <div className="flex flex-row items-center gap-4">
                    <div className="flex items-center" dir="ltr">
                      <span className="text-base" style={{ fontFamily: "monospace", letterSpacing: "6px" }}>
                        POSTMAN
                      </span>
                      <span
                        className="text-[#282929] text-base ml-2 font-bold"
                        style={{ fontFamily: "monospace" }}
                      >
                        Collection
                      </span>
                    </div>
                    <img alt="Postman" src={PostmanImage} />
                  </div>
                </div>
                <div className="flex w-full border border-[#CAD1DE] rounded-md min-h-[72px] flex-row items-center justify-between px-4 ">
                  <a target="_blank" href="https://api.chortke.app/documents" className="flex flex-row p-4">
                    <DownloadIcon color="#1062D0" />
                  </a>
                  <div className="flex flex-row items-center gap-4">
                    <div className="flex items-center" dir="ltr">
                      <span className="text-base text-[#1A5576] font-bold">Swagger</span>
                      <span
                        className="text-[#282929] text-base ml-2 font-bold"
                        style={{ fontFamily: "monospace" }}
                      >
                        Document
                      </span>
                    </div>
                    <div className="w-12 h-12 rounded-md border border-slate-300 flex items-center justify-center">
                      <img alt="Swagger" src={SwaggerImage} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <>
              <Typography color="#666666" sx={{ mb: 3 }}>
                استفاده از رابط برنامه نویسی برای اشتراک شما فعال نشده است. برای فعالسازی باید اشتراک خود را
                ارتقاء دهید
              </Typography>
              <NotAvailable handleClick={() => navigate("/business/extend")} />
            </>
          )}
        </Grid>
      </Grid>
    </InfoContainer>
  );
};

export default API;

const Download = () => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#a)">
      <path
        d="M13.246 10.127a.834.834 0 0 0-.746-.46h-1.667V1.333a.833.833 0 1 0-1.666 0v8.334H7.5A.834.834 0 0 0 6.833 11l2.5 3.333c.011.014.028.02.04.033.055.065.12.115.192.16.03.019.053.043.086.058.107.05.223.083.35.083a.825.825 0 0 0 .35-.083c.03-.015.055-.04.084-.057a.813.813 0 0 0 .193-.161c.01-.014.028-.018.039-.033l2.5-3.333c.19-.252.22-.59.079-.873Z"
        fill="#E3E4E5"
      />
      <path
        d="M19.167 13a.833.833 0 0 0-.834.833v2.5c0 1.379-1.121 2.5-2.5 2.5H4.167a2.503 2.503 0 0 1-2.5-2.5v-2.5a.833.833 0 1 0-1.667 0v2.5A4.171 4.171 0 0 0 4.167 20.5h11.666A4.171 4.171 0 0 0 20 16.333v-2.5a.833.833 0 0 0-.833-.833Z"
        fill="#E3E4E5"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" transform="translate(0 .5)" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);
